import App from "./App";
import axios from "axios";
import BootstrapVue from "bootstrap-vue";
import Default from "./layouts/Default";
import DeleteModal from "./utils/delete-modal";
import LogRocket from "logrocket";
import PatientModal from "./utils/patient-modal";
import router from "@/router";
import store from "./store/index";
import Toasted from "vue-toasted";
import Vue from "vue";
import VueAxios from "vue-axios";
import VueNativeSock from "vue-native-websocket";
import VueClipboard from "vue-clipboard2";
import VueFormWizard from 'vue-form-wizard';
import Vuelidate from 'vuelidate'
import moment from 'moment';
import VueMoment from 'vue-moment';
import 'vue-form-wizard/dist/vue-form-wizard.min.css';
import '@icon/themify-icons/themify-icons.css';

// libs
LogRocket.init("awfvwj/nft");
Vue.use(VueAxios, axios);
Vue.use(BootstrapVue);
Vue.use(Toasted, {
  position: "bottom-left",
  duration: 5000,
  theme: "outline",
  action: {
    text: "x",
    onClick: (e, toastObject) => {
      toastObject.goAway(0);
    }
  }
});
Vue.use(VueClipboard);
Vue.use(VueFormWizard);
Vue.use(Vuelidate)
Vue.use(VueMoment, { moment });

// custom plugins
Vue.use(DeleteModal);
Vue.use(PatientModal);

// layouts
Vue.component("default", Default);

// sockets
Vue.use(
  VueNativeSock,
  "ws://127.0.0.1:8000/socket/" + localStorage.getItem("token"),
  {
    connectManually: true,
    store: store,
    format: "json"
  }
);

// custom directives
Vue.directive("click-outside", {
  bind: function(el, binding, vnode) {
    el.clickOutsideEvent = function(event) {
      // here I check that click was outside the el and his childrens
      if (!(el === event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener("mousedown", el.clickOutsideEvent);
  },
  unbind: function(el) {
    document.body.removeEventListener("mousedown", el.clickOutsideEvent);
  }
});

new Vue({
  store: store,
  router,
  render: h => h(App)
}).$mount("#app");
